import { Component } from "react"

/* Components */
import { Input } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { password as changePassword } from "../../api/Manager"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"
import { CloseIcon, InfoIcon } from "./ManagerIcons"

/* Sweet alert */
import Swal from "../../helpers/alert"


/* Widget Manager Password */
class ManagerPassword extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            id: 0,
            name: "",
            password: "",
            repeatPassword: "",
            waiting: false,
        }
    }

    /* Open Action */
    open = ({ id, name }) => {
        this.setState({
            visible: true,
            id: utils.checkValue(id, 0),
            name: utils.checkValue(name, ""),
            password: "",
            repeatPassword: "",
            waiting: false,
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, id: 0, name: "", password: "", repeatPassword: "", waiting: false })
    }

    /* Generate Password */
    generate = () => {
        const password = utils.generatePassword()
        this.setState({ password, repeatPassword: password })
    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { id, password, repeatPassword } = this.state

        /* Check Password */
        if (!password) {
            this._password.error(t("manager.error.emptyPassword"))
            return
        }

        /* Check Password Length */
        if (password.length < 8) {
            this._password.error(t("manager.error.shortPassword"))
            return
        }

        /* Check Repeat */
        if (password !== repeatPassword) {
            this._repeatPassword.error(t("profile.error.mismatch"))
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Send to REST API */
        changePassword({ id, password }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("manager.passwordSaved"), "success"))
                this.close()
            }
            else if (response.data && response.data.message) {
                Swal.fire(utils.notification(response.data.message, "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    render = () => {

        /* Fields */
        const { visible, name, password, repeatPassword, waiting } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="manager--modal"
                overlayClassName="manager--overlay"
                closeTimeoutMS={200}
            >

                <div className="manager--modal-header">

                    <div>
                        <h2>{t("manager.changePassword")}</h2>
                        <p>{name}</p>
                    </div>

                    <div onClick={() => this.close()} className="manager--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="manager--modal-body">

                    <Input ref={(ref) => this._password = ref} label={t("manager.newPassword")} value={password} onChange={(event) => this.setState({ password: event.target.value })} secure />
                    <Input ref={(ref) => this._repeatPassword = ref} label={t("manager.repeatNewPassword")} value={repeatPassword} onChange={(event) => this.setState({ repeatPassword: event.target.value })} secure />

                    <div onClick={() => this.generate()} className="manager--generate">{t("common.generatePassword")}</div>

                    <div className="manager--section">
                        <div className="manager--hint">
                            <InfoIcon />
                            <span>{t("manager.passwordHint")}</span>
                        </div>
                    </div>

                </div>

                <div className="manager--modal-footer">

                    <div onClick={() => this.close()} className="manager--button ghost">{t("common.cancel")}</div>

                    {waiting
                        ? <div className="manager--button primary"><LoadingOutlined /></div>
                        : <div onClick={() => this.save()} className="manager--button primary">{t("common.save")}</div>
                    }

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(ManagerPassword)
